'use strict';

// import $ from 'jquery';  // used by Foundation
import { Foundation } from 'foundation/foundation.core';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';

export default function reflow(element)
{
    Foundation.plugin(OffCanvas);
    Foundation.reflow(element || document, 'off-canvas');
}
